<div class="container mt-3 mx-auto">
    <div class="alert alert-info" *ngIf="!notas || !notas.length">
        Não foram encontradas notas com os filtros informados.
    </div>

    <div class="row" *ngIf="notas && notas.length">
        <div *ngIf="dataHoraResultado" class="float-start letra-miuda">atualizado em: {{ dataHoraResultado }}</div>
        <bn-paginacao
            [total]="atributosPaginacao.count"
            [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
            [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th id="col-agente" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'agenteFinanceiroDestinatario'"
                                    [nomeAtributoExibicao]="'Agente financeiro'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                        
                            <th id="col-idOperacaoExterno" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'idOperacaoExterno'" 
                                    [nomeAtributoExibicao]="'Id. externo operação:'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-sistema-contrato" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'contratoRepasse'" 
                                    [nomeAtributoExibicao]="'Sist/Contrato'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th id="col-mensagem" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'mensagem'" 
                                    [nomeAtributoExibicao]="'Descrição'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th id="col-estado" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'ativo'" 
                                    [nomeAtributoExibicao]="'Estado'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th scope="col" class="text-start">
                                ações
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let nota of notas">
                            <td>{{ nomeAgenteFinanceiro(nota.idAgenteFinanceiro) }}</td>
                            <td>{{ nota.idOperacaoExterno }}</td>
                            <td>{{ nota.contratoRepasse ? nota.sistemaRepasse + '/' + nota.contratoRepasse : ''}}</td>
                            <td>{{ reduzirMensagemNota(nota,30) }}
                                <bn-dica *ngIf="nota.mensagem.length>30">{{nota.mensagem}}</bn-dica>
                            </td>
        
                            <td>{{ nota.ativo =='S' ? 'Ativo' : 'Excluído'}}</td>                            
                            <td class="text-start" id=col-acoes>
                                <a [routerLink]="['/notas/', nota.id]" >
                                    <i class="fa fa-search cursor-pointer" placement="left-top" [ngbTooltip]="podeCadastrarNota ? 'Visualizar/Editar Nota' : 'Visualizar Nota'"> </i></a>
                                <a href="javascript:void(0)" (click)="desativar(nota)" *ngIf="nota.ativo === 'S' && podeCadastrarNota"> 
                                    <i class="fa fa-trash cursor-pointer margin-left-5"    placement="left-top" ngbTooltip="Desativar Nota"></i></a>                                    
                                <a href="javascript:void(0)" (click)="exportarAnexo(nota)" *ngIf="nota.nomeAnexo">
                                    <i class=" fa fa-download cursor-pointer margin-left-5" ngbTooltip="Exportar Anexo"></i></a>
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </bn-paginacao>
    </div>
</div>